var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var Education = (function() {

    var _requestEducation = function() {
      return {
        type: constants.REQUEST_EDUCATION
      };
    }

    var _receiveEducation = function(data) {
      return {
        type: constants.RECEIVE_EDUCATION,
        bodyparts: data.bodyparts.bodyparts,
        symptoms: data.symptoms.symptoms,
        diseases: data.diseases.diseases,
        qols: data.qols.symptoms,
        receivedAt: Date.now()
      };
    }

    var _fetchEducation = function() {
      return function (dispatch) {
        dispatch(_requestEducation());
        return api.get('/educationproxy').then(function (response) {
          return response;
        }).then(function (data) {
          return dispatch(_receiveEducation(data));
        }).catch(function(error){
          if(error.response){
            dispatch(commonActions.setGenericResponseError('', error.response));
          }else{
            dispatch(commonActions.setGenericError('', error.message));
          }
        });
      };
    }

    var _shouldFetchEducation = function(state) {
      var education = state.education
      if (!education.bodyparts) {
        return true
      } else {
        return false
      }
    }

    var _fetchEducationIfNeeded = function() {
      return function(dispatch, getState) {
        if (_shouldFetchEducation(getState())) {
          return dispatch(_fetchEducation())
        }
      }
    }

    var _setActiveBodyParts = function(bodyParts) {
      return {
        type: constants.SET_ACTIVE_BODYPARTS,
        bodyParts: bodyParts
      };
    }

    var _setActiveEducationToggle = function(toggleType) {
      return {
        type: constants.SET_ACTIVE_EDUCATION_TOGGLE,
        toggleType: toggleType
      };
    }

    var _setThanksRegisteringMessage = function(thanksRegisteringMessage){
        return {
          type: constants.SET_THANKS_REGISTERING_MESSAGE,
          thanksRegisteringMessage: thanksRegisteringMessage || 'Thanks for registering!  Start learning more about *your* GI conditions in the Education Center and the most effective treatments in the Treatment Center'
        };
    }

    var _clearThanksRegisteringMessage = function(){
        return {
          type: constants.CLEAR_THANKS_REGISTERING_MESSAGE
        };
    }

    return {
        requestEducation: _requestEducation,
        receiveEducation: _receiveEducation,
        fetchEducation: _fetchEducation,
        shouldFetchEducation: _shouldFetchEducation,
        fetchEducationIfNeeded: _fetchEducationIfNeeded,
        setActiveBodyParts: _setActiveBodyParts,
        setActiveEducationToggle: _setActiveEducationToggle,
        setThanksRegisteringMessage: _setThanksRegisteringMessage,
        clearThanksRegisteringMessage: _clearThanksRegisteringMessage
    }
})();

module.exports = Education;


// WEBPACK FOOTER //
// ./src/common/modules/education/actions/education.js